// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3vQ-B","notes":"Notes_notes__9cDWo"};